import { fr } from "../content/fr";
import { IMG } from "./images";

// Module-level store of server-side SEO overrides, set at boot.
let _seo = {};
export function getContentSeo() { return _seo; }

function deepSet(obj, path, value) {
  const keys = path.split(".");
  let cur = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    if (cur[k] === undefined || cur[k] === null) {
      cur[k] = /^\d+$/.test(keys[i + 1]) ? [] : {};
    }
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
}

// Mutates the shared `fr` and `IMG` objects with DB overrides, before first render.
export function applyContent(data) {
  if (!data) return;
  if (data.overrides) {
    for (const [p, v] of Object.entries(data.overrides)) deepSet(fr, p, v);
  }
  if (data.images) {
    for (const [p, v] of Object.entries(data.images)) deepSet(IMG, p, v);
  }
  _seo = data.seo || {};
}

// Flattens a nested content object into [{ path, value }] for string/number leaves only.
export function flattenContent(obj, exclude = []) {
  const out = [];
  const walk = (o, pre) => {
    if (Array.isArray(o)) {
      o.forEach((v, i) => walk(v, pre ? `${pre}.${i}` : `${i}`));
    } else if (o && typeof o === "object") {
      for (const [k, v] of Object.entries(o)) {
        const path = pre ? `${pre}.${k}` : k;
        if (!pre && exclude.includes(k)) continue;
        walk(v, path);
      }
    } else if (typeof o === "string" || typeof o === "number") {
      out.push({ path: pre, value: o });
    }
  };
  walk(obj, "");
  return out;
}
